/**
 * Loại phí
 * nddat1 30/01/2023
 */
export default {
  Fee: 1,
  Fees: 2,
};
